import { render, staticRenderFns } from "./ChatbotModal.vue?vue&type=template&id=24a99f01&scoped=true"
import script from "./ChatbotModal.vue?vue&type=script&lang=js"
export * from "./ChatbotModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a99f01",
  null
  
)

export default component.exports